import {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {getGroupItemList} from "../../../core/api/optionApis";

export const useColorTargets = (isSingle, colorItemObject) => {
  const currentProduct = useSelector(state => state.optionWindow.currentVehicle);
  const [colorTargets, setColorTargets] = useState([]);

  useEffect(() => {
    let isMounted = true;

    if (isSingle || isSingle === undefined) {
      if (isMounted) {
        setColorTargets([]);
      }
    } else if (isSingle === false && colorItemObject?.partGroupId) {
      getGroupItemList(currentProduct.id, "COLOR", colorItemObject.partGroupId)
        .then(res => {
          if (!isMounted) return; // unmount 체크

          if (res.data.result && res.data.message === "SUCCESS") {
            const partGroupItems = res.data.data['partGroupItems'];
            const colorTargetList = ["INT_" + colorItemObject.colorTarget];

            for(let i = 0; i < partGroupItems.length; i++) {
              const target = "INT_" + partGroupItems[i].colorTarget;
              colorTargetList.push(target);
            }

            setColorTargets(colorTargetList);
          }
        })
        .catch(err => {
          console.error("Color targets fetch error:", err);
        });
    }

    return () => {
      isMounted = false;
    };
  }, [isSingle, colorItemObject?.partGroupId, currentProduct.id]);

  return colorTargets;
};
